import { SVGProps } from 'react';

const HotIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 200 200"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            fill="#fff"
            style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 1.41421,
            }}
            {...props}
        >
            <g id="Fire">
                <path d="M81.649,185.403c-3.45,1.354 -7.206,2.097 -11.134,2.097c-16.85,0 -30.53,-13.68 -30.53,-30.53c0,-37.9 12.811,-98.227 18.633,-128.989c-0.039,15.765 6.445,33.135 14.355,50.71c-7.385,26.929 -13.928,55.976 -13.928,74.347c0,14.855 9.418,27.527 22.604,32.365Z" />
                <path d="M140.981,57.596c-0.445,25.853 -49.889,66.81 -49.889,95.442c0,19.02 15.441,34.462 34.461,34.462c19.02,0 34.462,-15.442 34.462,-34.462c0,-28.632 -13.878,-78.924 -19.034,-95.442Z" />
                <path d="M108.991,185.994c-3.194,0.979 -6.586,1.506 -10.1,1.506c-19.02,0 -34.462,-15.442 -34.462,-34.462c0,-42.161 34.462,-140.538 34.462,-140.538c0,0 12.783,36.491 22.778,74.549c-14.783,22.022 -37.039,46.779 -37.039,65.989c0,15.506 10.263,28.634 24.361,32.956Z" />
            </g>
        </svg>
    );
};

export default HotIcon;
